export default __webpack_public_path__ + "static/media/grid.d53fd1e4.PNG";